import SharedModal from './Modal';

export default SharedModal;
